import { useTranslation } from "react-i18next";
import styles from "../NewAddresses/Addresses.module.css";
import Item from "./Item/Item";
import { useEffect } from "react";

const ShippingOptions = ({
  shippingOptions = [],
  selectedShippingOption,
  setSelectedShippingOption,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    setSelectedShippingOption(shippingOptions[0].id);
  }, [shippingOptions]);

  return (
    <div className={styles.AddressesContainer}>
      <h2>{t("cart.shipping_options")}</h2>
      <div className="mt-3">
        {shippingOptions.map((shippingOption) => {
          return (
            <Item
              {...shippingOption}
              active={selectedShippingOption === shippingOption.id}
              onClick={() => setSelectedShippingOption(shippingOption.id)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ShippingOptions;
